import Component from '../generic-summary/generic-summary.desktop';
import getCbtSummary from './cbt-summary';

const cbtSummary = getCbtSummary(Component);

export default cbtSummary;
